import { FC } from "react";
import { SigmaEmbed } from "@velocity-ehs/component-library";
import UsersService from "@velocity-ehs/user-utils-module";
import { useFlags } from "launchdarkly-react-client-sdk";
import {
  getSigmaAccountType,
  getSigmaTeamNames,
} from "../../supportFunctions/Sigma";

const SigmaDashboard: FC = () => {
  const { showSigmaFooter } = useFlags();

  return (
    <SigmaEmbed
      embedInformation={{
        embedGeneratorUrl: process.env.SIGMA_EMBED_GENERATOR,
        accountType: getSigmaAccountType(),
        worksheetId: process.env.SIGMA_DASHBOARD_WORKSHEET_ID, //TODO: will change to lookup from Sigma post demo
        email: UsersService.user.email,
        clientId: UsersService.user.userCustomerId,
        userTeam: getSigmaTeamNames(),
        userId: UsersService.user.id,
        showFooter: showSigmaFooter,
      }}
    />
  );
};

export default SigmaDashboard;
